import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-export',
  templateUrl: './help-add-export.component.html',
  styleUrls: ['./help-add-export.component.scss']
})
export class HelpAddExportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
